import React from 'react';

export default function Loading(props) {
    if (props.error) return <>Something went wrong, and data could not be fetched</>
    return (
        <>
            Please wait
        </>
    )
}